<template>
  <div>
    <v-btn color="green" class="" icon x-large @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Add Batch Item Import"
          icon="mdi-plus-box"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-select
            outlined
            dense
            :items="suppliers"
            v-model="form.supplier_id"
            item-text="supplier_name"
            item-value="id"
            label="Supplier"
            prepend-icon="mdi-account-group"
            @change="onSupplierChange"
          ></v-select>
          <v-text-field
            dense
            label="Batch Description / Tag *"
            v-model="form.batch_description"
            prepend-icon="mdi-list-box"
            :loading="tagLoading"
            hint="Auto-filled from the supplier's batch prefix; you can edit it."
            persistent-hint
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Capital Amount"
            prepend-icon="mdi-cash"
            type="number"
            v-model="form.capital_amount"
          ></v-text-field>
          <div class="d-flex align-center mb-3">
            <p class="mr-2 mb-0">Date Ordered</p>
            <input type="date" v-model="form.date_ordered" />
          </div>
          <div class="d-flex align-center">
            <p class="mr-2 mb-0">Date Arrived</p>
            <input type="date" v-model="form.date_arrived" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="submit"
            :loading="loading"
            :disabled="loading"
            >Submit</v-btn
          >
          <v-btn @click="closeDialog" :disabled="loading">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  // Optional supplier to pre-select when the dialog opens (e.g. passed from the
  // restock / add-item forms so the batch tag auto-fills without re-picking). (JMB-18)
  props: {
    presetSupplierId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      form: {
        batch_description: "",
        supplier_id: "",
        capital_amount: "",
        // Default to today so the NOT NULL date_ordered is never submitted
        // empty. Both remain editable. (JMB-18)
        date_ordered: today,
        date_arrived: today,
      },
      dialog: false,
      loading: false,
      tagLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      suppliers: "supplier/suppliers",
    }),
  },
  watch: {
    // When the modal opens with a preset supplier, select it and auto-fill the tag.
    dialog(isOpen) {
      if (isOpen && this.presetSupplierId && !this.form.supplier_id) {
        this.form.supplier_id = this.presetSupplierId;
        this.onSupplierChange(this.presetSupplierId);
      }
    },
  },
  methods: {
    ...mapActions({
      add_import_batch: "importBatch/add_import_batch",
      get_next_batch_tag: "importBatch/get_next_batch_tag",
    }),
    // When a supplier is picked, auto-fill the batch description with the next
    // batch tag (PREFIX-SEQUENCE-BRANCHLETTER). Editable afterwards. (JMB-18)
    async onSupplierChange(supplierId) {
      if (!supplierId) return;
      this.tagLoading = true;
      try {
        const data = await this.get_next_batch_tag(supplierId);
        if (data && data.batch_tag) {
          this.form.batch_description = data.batch_tag;
        }
      } catch (err) {
        // Non-fatal: leave the description for manual entry.
        console.error("Failed to fetch next batch tag:", err);
      } finally {
        this.tagLoading = false;
      }
    },
    async submit() {
      if (!this.form.batch_description) {
        this.$alert({
          title: "Validation",
          message: "Batch Description is required.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      // date_ordered is NOT NULL on import_batches — guard against an empty value. (JMB-18)
      if (!this.form.date_ordered) {
        this.$alert({
          title: "Validation",
          message: "Date Ordered is required.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      this.loading = true;
      try {
        let x = await this.$confirm({
          title: "Add Batch Import",
          message: "Are you sure you want to proceed?",
          color: "primary",
          icon: "mdi-help-circle-outline",
        });
        if (x) {
          const created = await this.add_import_batch(this.form);
          this.$emit("added", created);
          this.resetForm();
          this.dialog = false;
        }
      } catch (err) {
        // Error already shown by the store action
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      const today = new Date().toISOString().slice(0, 10);
      this.form = {
        batch_description: "",
        supplier_id: "",
        capital_amount: "",
        date_ordered: today,
        date_arrived: today,
      };
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped></style>
